import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { ConditionalFormModule } from '../conditional-form/conditional-form.module';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { PostTradeComponent } from './post-trade-shell/post-trade.component';
import { PostTradeReportsComponent } from './post-trade-reports/post-trade-reports.component';
import { ReviewDownloadDialogComponent } from './components/review-download-dialog/review-download-dialog.component';
import { TradeReviewComponent } from './trade-review/trade-review-shell/trade-review.component';
import { TradeReviewDashboardComponent } from './trade-review/trade-review-dashboard/trade-review-dashboard.component';
import { TradeReviewDetailComponent } from './trade-review/trade-review-detail/trade-review-detail.component';
import { TradeSourceDataComponent } from './trade-source-data/trade-source-data.component';
import { MultiTableCardComponent } from './components/multi-table-card/multi-table-card.component';
import { RecordsAccordionComponent } from './components/records-accordion/records-accordion.component';
import { HoldingsCardComponent } from './components/holdings-card/holdings-card.component';
import { ExpandingTableComponent } from './components/expanding-table/expanding-table.component';
import { BasicTableComponent } from './components/basic-table/basic-table.component';
import { CardInfopointComponent } from './components/card-infopoint/card-infopoint.component';
import { PostTradeChartComponent } from './components/post-trade-chart/post-trade-chart.component';
import { ApprovalMenuComponent } from './components/approval-menu/approval-menu.component';
import { AlertsDialogComponent } from './components/alerts-dialog/alerts-dialog.component';
import { AttachmentsDialogComponent } from './components/attachments-dialog/attachments-dialog.component';
import { AttachmentsWidgetComponent } from './components/attachments-widget/attachments-widget.component';
import { AccountReviewComponent } from './account-review/account-review-shell/account-review.component';
import { AccountReviewDashboardComponent } from './account-review/account-review-dashboard/account-review-dashboard.component';
import { AccountReviewDetailComponent } from './account-review/account-review-detail/account-review-detail.component';
import { AccountHistoryDialogComponent } from './account-review/account-review-detail/account-history-dialog/account-history-dialog.component';
import { RepReviewComponent } from './rep-review/rep-review-shell/rep-review.component';
import { RepReviewDetailComponent } from './rep-review/rep-review-detail/rep-review-detail.component';
import { RepReviewDashboardComponent } from './rep-review/rep-review-dashboard/rep-review-dashboard.component';
import { AmlMonitorComponent } from './aml-monitor/aml-monitor-shell/aml-monitor.component';
import { AmlMonitorDetailComponent } from './aml-monitor/aml-monitor-detail/aml-monitor-detail.component';
import { AmlMonitorDashboardComponent } from './aml-monitor/aml-monitor-dashboard/aml-monitor-dashboard.component';
import { AccountGroupingDialogComponent } from './account-grouping/account-grouping-dialog/account-grouping-dialog.component';
import { AccountGroupingComponent } from './account-grouping/account-grouping-shell/account-grouping.component';
import { AccountGroupingDetailComponent } from './account-grouping/account-grouping-detail/account-grouping-detail.component';
import { ExternalGroupingDialogComponent } from './account-grouping/external-grouping-dialog/external-grouping-dialog.component';
import { OpenRecordsTableComponent } from './components/open-records-table/open-records-table.component';
import { AgingCasesTableComponent } from './components/aging-cases-table/aging-cases-table.component';
import { CaseCreationDialogComponent } from './components/case-creation-dialog/case-creation-dialog.component';

//Kendo Imports
import { GridModule } from '@progress/kendo-angular-grid';

//Services
import { AuthService } from '../services/auth-service.service';
import { RightBridgeApiService } from '../services/right-bridge-api.service';
import { PostTradeService } from './post-trade.service';

import { PostTradeRouting } from './post-trade-routing.module';

@NgModule({
  imports: [
    MatDialogModule,
    MatSelectModule,
    CommonModule,
    RouterModule,
    PostTradeRouting,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    GridModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circle,
      backdropBackgroundColour: 'rgba(0, 0, 0, 0.3)',
      fullScreenBackdrop: true,
      backdropBorderRadius: '0',
      primaryColour: 'rgb(38, 91, 151)',
      secondaryColour: 'rgba(38, 91, 151, 0.2)',
      tertiaryColour: '#265b97',
    }),
    SharedComponentsModule,
  ],
  declarations: [
    PostTradeComponent,
    PostTradeReportsComponent,
    ReviewDownloadDialogComponent,
    TradeReviewComponent,
    TradeReviewDashboardComponent,
    TradeReviewDetailComponent,
    TradeSourceDataComponent,
    MultiTableCardComponent,
    RecordsAccordionComponent,
    HoldingsCardComponent,
    ExpandingTableComponent,
    BasicTableComponent,
    CardInfopointComponent,
    PostTradeChartComponent,
    ApprovalMenuComponent,
    AlertsDialogComponent,
    AttachmentsDialogComponent,
    AttachmentsWidgetComponent,
    AccountReviewComponent,
    AccountReviewDashboardComponent,
    AccountReviewDetailComponent,
    AccountHistoryDialogComponent,
    RepReviewComponent,
    RepReviewDetailComponent,
    RepReviewDashboardComponent,
    AmlMonitorComponent,
    AmlMonitorDetailComponent,
    AmlMonitorDashboardComponent,
    AccountGroupingDialogComponent,
    AccountGroupingComponent,
    AccountGroupingDetailComponent,
    ExternalGroupingDialogComponent,
    OpenRecordsTableComponent,
    AgingCasesTableComponent,
    CaseCreationDialogComponent,
  ],
  providers: [RightBridgeApiService, PostTradeService, AuthService],
  schemas: [NO_ERRORS_SCHEMA],
})
export class PostTradeModule {}
